import $ from 'jquery';

$('[data-modal]').on('click', function (event) {
    let id = $(this).data('modal');
    let popup = $('#' + id);

    if (!popup.length) {
        return;
    }

    event.preventDefault();
    popup.fadeIn().toggleClass('active');

    playOrPauseModalVideo(popup);

    window.scroll_position = $(window).scrollTop();
    $('body')
        .css('position', 'fixed')
        .css('overflow', 'hidden')
        .css('width', '100%');
});

$('.modal__close-button').on('click', function () {
    let popup = $( '#' + $(this).data('target'));
    popup.fadeOut().toggleClass('active');

    playOrPauseModalVideo(popup);

    $('body')
        .css('position', '')
        .css('overflow', '')
        .css('width', 'auto');
    $(window).scrollTop(window.scroll_position);
});

$(document).keydown(function(event) {
    if (event.keyCode == 27) {
        const modal = $('.modal.active');
        modal.fadeOut().toggleClass('active');
        playOrPauseModalVideo(modal);

        $('body')
            .css('position', '')
            .css('overflow', '')
            .css('width', 'auto');
        $(window).scrollTop(window.scroll_position);
    }
});

function playOrPauseModalVideo (modal) {
    if (modal.get(0).id !== 'videoModal') {
        return;
    }

    const video = modal.find('video').get(0);

    if (modal.hasClass('active')) {
        video.play();
    } else {
        video.pause();
    }
}
